// Section code is requested only when its markup exists.
export default [
    {
        selector: '.faq-section',
        load: () => import(/* webpackChunkName: "section-faq" */ './sections/faq'),
    },
    {
        selector: '.geography-section',
        load: () => import(/* webpackChunkName: "section-geography" */ './sections/geography'),
    },
    {
        selector: '.showcase-section',
        load: () => import(/* webpackChunkName: "section-showcase" */ './sections/showcase'),
    },
];
